import React, { ReactElement } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import Criterion from "./Criterion";

interface Props {
  criterions: {
    key: string;
    value: number;
    set: boolean;
  }[];
  setCriterions: React.Dispatch<
    React.SetStateAction<
      {
        key: string;
        value: number;
        set: boolean;
      }[]
    >
  >;
}

export default function CriterionsTable({
  criterions,
  setCriterions,
}: Props): ReactElement {
  const setCriterion = (idx: number, id: string, val: number, set: boolean) => {
    let tmp = [...criterions];
    tmp[idx].key = id;
    tmp[idx].value = val;
    tmp[idx].set = set;
    setCriterions(tmp);
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>
            <b>Criterion</b>
          </TableCell>
          <TableCell>
            <b>Use</b>
          </TableCell>
          <TableCell>
            <b>Value</b>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {criterions.map((e, i) => (
          <Criterion
            id={e.key}
            key={i}
            idx={i}
            value={e.value}
            set={e.set}
            setCriterion={setCriterion}
          />
        ))}
      </TableBody>
    </Table>
  );
}
